import $ from 'jquery';
import debounce from './utils/debounce';

require('intersection-observer');

class Header {
    constructor () {
        this.$document        = $(document);
        this.$window          = $(window);
        this.$body            = $('body');
        this.speed            = 200;
        this.mobileBreakpoint = 1023;
        this.$page            = $('.js-page');
        this.$homeContent     = $('.js-home-content');

        // Header
        this.$header                  = $('.js-header');
        this.$frontPageStrapline      = $('.js-front-page-strapline');
        this.headerHeight             = this.$header.outerHeight(true);
        this.frontPageStraplineHeight = this.$frontPageStrapline.outerHeight(true);
        this.$mainMenu                = $('.js-main-menu');
        this.$pageHeader              = $('.js-page-header');
        this.pageHeaderHeight         = this.$pageHeader.outerHeight(true);

        // Search
        this.$searchForm        = $('.js-search-form');
        this.$searchField       = $('.js-search-field');
        this.$searchOpenButton  = $('.js-search-open');
        this.$searchCloseButton = $('.js-search-close');

        // Mobile Menu
        this.$openMenuButton  = $('.js-menu-open');
        this.$closeMenuButton = $('.js-menu-close');
        this.$mobileMenu      = $('.js-mobile-menu');
        this.$radialOverlay   = $('.js-radial-overlay');

        // Footer
        this.$footer            = $('.js-footer');
        this.$footerPlaceholder = $('.js-footer-placeholder');
        this.$fixedFooter       = $('.js-fixed-footer');

        // -------

        // Search Events
        this.$searchOpenButton.on('click', $.proxy(this.openSearch, this));
        this.$searchCloseButton.on('click', $.proxy(this.closeSearch, this));

        // Mobile Menu Events
        this.$openMenuButton.on('click', $.proxy(this.openMenu, this));
        this.$closeMenuButton.on('click', $.proxy(this.closeMenu, this));
        this.$openMenuButton.on('click', $.proxy(this.radialOverlay, this));
        this.$closeMenuButton.on('click', $.proxy(this.radialOverlay, this));

        this.$window.on('load resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();

                // Close search on doc click
                this.$document.on('click', $.proxy(this.documentClick, this));

                this.$document.keyup((e) => {
                    // Escape Key
                    if (e.keyCode === 27) {
                        this.closeSearch();
                    }
                });
            }
        }, 300));

        // Functions running without debounce as it relies on animation timing
        this.$window.on('load resize', () => {
            if (this.$window.width() < this.mobileBreakpoint) {
                this.addMenuClass();
            } else {
                this.removeMenuClass();
            }
        });

        this.$window.on('scroll', () => {
            // General sticky header
            this.stickyHeader();
        });

        this.observeHomeContent();
    }

    documentClick (e) {
        const $elem = $(e.target);

        if (!$elem.closest(this.$searchForm).length && !$elem.closest(this.$searchOpenButton).length && this.$header.hasClass('search-is-open')) {
            this.closeSearch();
        }
    }

    closeSearch (e) {
        if (typeof e !== 'undefined') {
            e.preventDefault();
        }

        let fadeSpeed = this.speed;

        if (this.$header.hasClass('sticky-is-visible')) {
            fadeSpeed = 0;
        }

        this.$searchForm.fadeOut(fadeSpeed);
        this.$header.removeClass('search-is-open');
        this.$body.removeClass('has-overlay scroll-locked');
        this.$page.removeClass('overlay-is-open');
        this.$mainMenu.removeClass('is-hidden');
        this.$footer.removeClass('is-static');
        this.$fixedFooter.removeClass('unset-z-index');
        this.$footerPlaceholder.show();
    }

    openSearch () {
        this.$searchForm.fadeIn(this.speed, () => {
            this.$searchField.focus();
        });

        this.$header.addClass('search-is-open');
        this.$body.addClass('has-overlay scroll-locked');
        this.$page.addClass('overlay-is-open');
        this.$mainMenu.addClass('is-hidden');
        this.$footer.addClass('is-static');
        this.$fixedFooter.addClass('unset-z-index');
        this.$footerPlaceholder.hide();

        $('html, body').animate({
            scrollTop: this.$header.offset().top
        }, 100);
    }

    openMenu () {
        this.$mobileMenu.addClass('is-open');
        this.$header.addClass('menu-is-open');
        this.$body.addClass('scroll-locked');
        let timeoutSpeed;
        // Wait for the menu animation to finish

        if (this.$header.hasClass('is-sticky')) {
            timeoutSpeed = 800;
        } else {
            timeoutSpeed = 0;
        }
        setTimeout(() => {
            this.$mainMenu.addClass('ready-to-animate');
        }, timeoutSpeed);
    }

    closeMenu () {
        this.$body.removeClass('scroll-locked');
        this.$mobileMenu.removeClass('is-open');
        this.$header.removeClass('menu-is-open');
        this.$mainMenu.removeClass('ready-to-animate');
    }

    addMenuClass () {
        let timeoutSpeed;

        if (this.$header.hasClass('is-sticky')) {
            timeoutSpeed = 800;
        } else {
            timeoutSpeed = 0;
        }

        if (!this.$mobileMenu.hasClass('is-mobile-menu')) {
            // Wait for menu animation to prevent the mobile menu appearing briefly on resize
            setTimeout(() => {
                this.$mobileMenu.addClass('is-mobile-menu');
            }, timeoutSpeed);
        }
    }

    removeMenuClass () {
        this.$mobileMenu.removeClass('is-mobile-menu');
    }

    resetEverything () {
        // Close
        this.closeSearch();

        // Reset Burger Menu
        this.$mobileMenu.removeClass('is-open');
    }

    observeHomeContent () {
        if (this.$homeContent.length) {
            const config              = {
                rootMargin: '0px 0px -100%'
            };
            const homeContentObserver = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.$header.addClass('is-sticky sticky-is-visible');
                    this.$frontPageStrapline.css('paddingBottom', `${this.headerHeight}px`);
                } else {
                    this.$header.removeClass('is-sticky sticky-is-visible');
                    this.$frontPageStrapline.css('paddingBottom', 0);
                }
            }, config);

            homeContentObserver.observe(this.$homeContent[0]);
        }
    }

    stickyHeader () {
        if (this.$pageHeader.length) {
            // Check if the page is using the WordPress admin bar. If it is, take the height of it away from the scrollTop to prevent jumpiness
            let windowScrollTop;
            if (this.$body.hasClass('admin-bar')) {
                windowScrollTop = this.$window.scrollTop() - 32;
            } else {
                windowScrollTop = this.$window.scrollTop();
            }

            if (windowScrollTop > (this.headerHeight)) {
                if (!this.$header.hasClass('is-sticky')) {
                    // Add class and negative top position to snap the sticky header out of view (64px is the height of the sticky header)
                    this.$header.addClass('is-sticky').css('top', '-64px');
                    // Reset the top position to 0 after the length of the sticky animation so it scrolls in and out of view properly
                    setTimeout(() => {
                        this.$header.css('top', 0);
                    }, 500);
                    this.$pageHeader.css('paddingTop', this.headerHeight);
                }
            } else {
                this.$header.removeClass('is-sticky');
                this.$pageHeader.css('paddingTop', 0);
            }

            if (windowScrollTop > (this.pageHeaderHeight + this.headerHeight)) {
                if (!this.$header.hasClass('sticky-is-visible')) {
                    this.$header.addClass('sticky-is-visible').css('top', 0);
                }
            } else {
                this.$header.removeClass('sticky-is-visible');
            }
        }
    }

    radialOverlay () {
        if (this.$header.hasClass('is-sticky')) {
            // eslint-disable-next-line no-restricted-properties
            const diameter = (Math.sqrt(Math.pow(this.$window.height(), 2) + Math.pow(this.$window.width(), 2)) * 2);
            this.$radialOverlay.toggleClass('is-clicked').css({
                scaleX: 0,
                scaleY: 0,
                translateZ: 0,
                height: `${diameter}px`,
                width: `${diameter}px`,
                top: `${-((diameter - this.$openMenuButton.innerHeight()) / 2)}px`,
                left: `${-((diameter - this.$openMenuButton.innerWidth()) / 2)}px`,
            });
        }
    }
}

export default Header;
